/** temporary until we swap to using the delivery option names from circuit-api-contracts */
export var DELIVERY_OPTION;
(function (DELIVERY_OPTION) {
    DELIVERY_OPTION[DELIVERY_OPTION["Standard"] = 1] = "Standard";
    DELIVERY_OPTION[DELIVERY_OPTION["SameDay"] = 2] = "SameDay";
    // TODO: Remove after ThreeHour is removed from delivery option contracts
    /** @deprecated Remove after ThreeHour is removed from delivery option contracts */
    DELIVERY_OPTION[DELIVERY_OPTION["ThreeHour"] = 3] = "ThreeHour";
    DELIVERY_OPTION[DELIVERY_OPTION["ClickAndCollect"] = 4] = "ClickAndCollect";
    DELIVERY_OPTION[DELIVERY_OPTION["SameDayAfternoon"] = 5] = "SameDayAfternoon";
})(DELIVERY_OPTION || (DELIVERY_OPTION = {}));
export const DELIVERY_OPTIONS = {
    [DELIVERY_OPTION.Standard]: {
        displayName: 'Standard',
        name: 'Standard',
    },
    [DELIVERY_OPTION.SameDay]: {
        displayName: 'This evening',
        displayNameAfterCutoff: 'Tomorrow evening',
        name: 'SameDay',
    },
    // TODO: Remove after ThreeHour is removed from delivery option contracts
    /** @deprecated Remove after ThreeHour is removed from delivery option contracts */
    [DELIVERY_OPTION.ThreeHour]: {
        displayName: 'As soon as possible',
        name: 'ThreeHour',
    },
    [DELIVERY_OPTION.ClickAndCollect]: {
        displayName: 'Click & collect',
        name: 'ClickAndCollect',
    },
    [DELIVERY_OPTION.SameDayAfternoon]: {
        displayName: 'This afternoon',
        displayNameAfterCutoff: 'Tomorrow afternoon',
        name: 'SameDayAfternoon',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hpcHBpbmdPcHRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9zaGlwcGluZ09wdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNEZBQTRGO0FBQzVGLE1BQU0sQ0FBTixJQUFZLGVBUVg7QUFSRCxXQUFZLGVBQWU7SUFDekIsNkRBQWMsQ0FBQTtJQUNkLDJEQUFhLENBQUE7SUFDYix5RUFBeUU7SUFDekUsbUZBQW1GO0lBQ25GLCtEQUFlLENBQUE7SUFDZiwyRUFBcUIsQ0FBQTtJQUNyQiw2RUFBc0IsQ0FBQTtBQUN4QixDQUFDLEVBUlcsZUFBZSxLQUFmLGVBQWUsUUFRMUI7QUFFRCxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRztJQUM5QixDQUFDLGVBQWUsQ0FBQyxRQUFRLENBQUMsRUFBRTtRQUMxQixXQUFXLEVBQUUsVUFBVTtRQUN2QixJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNELENBQUMsZUFBZSxDQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ3pCLFdBQVcsRUFBRSxjQUFjO1FBQzNCLHNCQUFzQixFQUFFLGtCQUFrQjtRQUMxQyxJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNELHlFQUF5RTtJQUN6RSxtRkFBbUY7SUFDbkYsQ0FBQyxlQUFlLENBQUMsU0FBUyxDQUFDLEVBQUU7UUFDM0IsV0FBVyxFQUFFLHFCQUFxQjtRQUNsQyxJQUFJLEVBQUUsV0FBVztLQUNsQjtJQUNELENBQUMsZUFBZSxDQUFDLGVBQWUsQ0FBQyxFQUFFO1FBQ2pDLFdBQVcsRUFBRSxpQkFBaUI7UUFDOUIsSUFBSSxFQUFFLGlCQUFpQjtLQUN4QjtJQUNELENBQUMsZUFBZSxDQUFDLGdCQUFnQixDQUFDLEVBQUU7UUFDbEMsV0FBVyxFQUFFLGdCQUFnQjtRQUM3QixzQkFBc0IsRUFBRSxvQkFBb0I7UUFDNUMsSUFBSSxFQUFFLGtCQUFrQjtLQUN6QjtDQUlGLENBQUMifQ==